import { APIService } from "./APIService"
import { AddDiscountType, DiscountType } from "./types"

const addDiscount = (body: AddDiscountType) =>
  APIService.post<null, DiscountType>(`/admin/tools/discounts`, body)

type DeleteUserBody = { email: string }

const deleteUser = (body: DeleteUserBody) =>
  APIService.delete<null, null>(`/admin/tools/users`, { data: body })

export const AdminToolsService = {
  addDiscount,
  deleteUser,
}
